@defer {
    <div class="pt-16" [innerHTML]="description()"></div>
}
